export default __webpack_public_path__ + "static/media/Right_arrow.af95ebe2.svg";